import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { getEarningById } from "../services/adminApi";

const EarningDetails = () => {

    const { id } = useParams();

    const [earning, setEarning] = useState(null);

    useEffect(() => {
        loadEarning();
    }, []);

    const loadEarning = async () => {

        try {

            const res = await getEarningById(id);

            setEarning(res.data.earning);

        } catch (err) {

            console.error(err);

        }

    };

    if (!earning)
        return <p>Loading...</p>;

    return (

        <div className="earning-details">

            <h2>Earning Details</h2>

            <table>

                <tbody>

                    <tr>

                        <td>Total Revenue</td>

                        <td>
                            ₹{earning.totalAmount}
                        </td>

                    </tr>

                    <tr>

                        <td>Commission</td>

                        <td>
                            ₹{earning.platformCommission}
                        </td>

                    </tr>

                    <tr>

                        <td>Provider</td>

                        <td>
                            ₹{earning.providerEarning}
                        </td>

                    </tr>

                    <tr>

                        <td>Delivery</td>

                        <td>
                            ₹{earning.deliveryEarning}
                        </td>

                    </tr>

                    <tr>

                        <td>Payment Status</td>

                        <td>
                            {earning.paymentStatus}
                        </td>

                    </tr>

                    <tr>

                        <td>Settlement</td>

                        <td>
                            {earning.settlementStatus}
                        </td>

                    </tr>

                </tbody>

            </table>

        </div>

    );

};

export default EarningDetails;